module.exports = "<div class=\"ui-g form-group ui-md-12\" *ngIf=\"mostrarCodigo\">\r\n  <base-info [text]=\"labelCodigo\" class=\"ui-g-12\" [value]=\"codigo\"></base-info>\r\n</div>\r\n<div class=\"ui-g form-group  ui-md-12\">\r\n  <base-info text=\"Nome do Profissional\" class=\"ui-g-8\" [value]=\"nome\"></base-info>\r\n  <base-info text=\"Registro\" class=\"ui-g-4\" [value]=\"registro\"></base-info>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Componentes/profissional-gerenciar-atividades/profissional-gerenciar-atividades.component.html
// module id = ./src/app/Componentes/profissional-gerenciar-atividades/profissional-gerenciar-atividades.component.html
// module chunks = main